import { useState } from "react"
import GateService from "../services/api"
import useGateStore from "../zustand/useGateStore"
import {useSnackbar} from "notistack";


export const useGates = () => {

    const {enqueueSnackbar} = useSnackbar();

    const {setGateCreated, setGateStatusUpdated, setGateDeleted} = useGateStore()

    const [isLoadingGetGates, setIsLoadingGetGates] = useState(false)
    const [gates, setGates] = useState([])
    const [errorGetGates, setErrorGetGates] = useState(null)

    const [isLoadingCreateGate, setIsLoadingCreateGate] = useState(false)
    const [createdGate, setCreatedGate] = useState(null)
    const [errorCreateGate, setErrorCreateGate] = useState(null)

    const [isLoadingViewGate, setIsLoadingViewGate] = useState(false)
    const [gate, setGate] = useState(null)
    const [errorViewGate, setErrorViewGate] = useState(null)

    const [isLoadingUpdateGateStatus, setIsLoadingUpdateGateStatus] = useState(false)
    const [updatedGateStatus, setUpdatedGateStatus] = useState(null)
    const [errorUpdateGateStatus, setErrorUpdateGateStatus] = useState(null)

    const [isLoadingDeleteGate, setIsLoadingDeleteGate] = useState(false)
    const [deletedGate, setDeletedGate] = useState(null)
    const [errorDeletedGate, setErrorDeletedGate] = useState(null)

    const [isFilteringGate, setFilteringGate] = useState(false);


    const getGates = (page, limit, status, type, location) => {
        setIsLoadingGetGates(true)
        setGates(null)
        setErrorGetGates(null)
        GateService.getGateList(page, limit, status, type, location).then((res) => {
            setIsLoadingGetGates(false)
            setGates(res.data.data)
        })
        .catch((error) => {
            console.error("Error fetching gate list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setIsLoadingGetGates(false)
            setErrorGetGates(error.response?.data)

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const createGate = (port_uid, type, status, gateName, location) => {
        setIsLoadingCreateGate(true)
        setCreatedGate(null)
        setGateCreated(false)
        setErrorCreateGate(null)
        GateService.createGate(port_uid, type, status, gateName, location).then((res) => {
            setIsLoadingCreateGate(false)
            if (res.data.success) {
                setGateCreated(true)
            }
            setCreatedGate(res.data.data)
        })
        .catch((error) => {
            console.error("Error creating gate:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setIsLoadingCreateGate(false)
            setErrorCreateGate(error.response?.data)

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const viewGate = (gateUID) => {
        setIsLoadingViewGate(true)
        setGate(null)
        setErrorViewGate(null)
        GateService.viewGate(gateUID).then((res) => {
            setIsLoadingViewGate(false)
            setGate(res.data.data)
        })
        .catch((error) => {
            console.error("Error fetching gate details:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setIsLoadingViewGate(false)
            setErrorViewGate(error.response?.data)

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateGateStatus = (gateUID, status) => {
        setIsLoadingUpdateGateStatus(true)
        setUpdatedGateStatus(null)
        setGateStatusUpdated(false)
        setErrorUpdateGateStatus(null)
        GateService.updateGateStatus(gateUID, status).then((res) => {
            setIsLoadingUpdateGateStatus(false)
            if (res.data.success) {
                setGateStatusUpdated(true)
            }
            setUpdatedGateStatus(res.data.data)
        })
        .catch((error) => {
            console.error("Error updating gate status:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setIsLoadingUpdateGateStatus(false)
            setErrorUpdateGateStatus(error.response?.data)

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const deleteGate = (gateUID) => {
        setIsLoadingDeleteGate(true)
        setDeletedGate(null)
        setGateDeleted(false)
        setErrorDeletedGate(null)
        GateService.deleteGate(gateUID).then((res) => {
            setIsLoadingDeleteGate(false)
            if (res.data.success) {
                setGateDeleted(true)
            }
            setDeletedGate(res.data.data)
        })
        .catch((error) => {
            console.error("Error deleting gate:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setIsLoadingDeleteGate(false)
            setErrorDeletedGate(error.response?.data)

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const filterGate = (parameters) => {
        setFilteringGate(true);
    
        GateService.filterGate(parameters).then((res) => {
            console.log("filterGate data xxxx", res);
    
            if (res.data.success) {
                setFilteringGate(false);
                setGates(res.data.data);
            } 
    
        }).catch((error) => {
            console.error("Error filtering gate list:", error);
            const errorMessage = error?.response?.data?.error || error.message;
    
            setGates([]);
            setFilteringGate(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }



    return {
        isLoadingGetGates, 
        gates, 
        errorGetGates,
        getGates, 

        isLoadingCreateGate,
        createdGate,
        errorCreateGate,
        createGate,

        isLoadingViewGate,
        gate,
        errorViewGate,
        viewGate,

        isLoadingUpdateGateStatus,
        updatedGateStatus,
        errorUpdateGateStatus,
        updateGateStatus,

        isLoadingDeleteGate,
        deletedGate,
        errorDeletedGate,
        deleteGate,

        filterGate,
        isFilteringGate,
    }
}